import { Plus, X } from "lucide-react";
import { ImageUpload, ImageListUpload } from "./ImageUpload";

const inputCls =
  "w-full rounded-xl border border-white/10 bg-glg-black/60 px-4 py-2.5 text-sm text-white outline-none focus:border-glg-blue";

function ListField({ value = [], onChange }) {
  const items = value || [];
  return (
    <div className="space-y-2">
      {items.map((v, i) => (
        <div key={i} className="flex gap-2">
          <input
            value={v}
            onChange={(e) => {
              const next = [...items];
              next[i] = e.target.value;
              onChange(next);
            }}
            className={inputCls}
          />
          <button type="button" onClick={() => onChange(items.filter((_, idx) => idx !== i))} className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-xl border border-white/15 text-white/60 hover:text-white">
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
      <button type="button" onClick={() => onChange([...items, ""])} className="inline-flex items-center gap-1.5 rounded-lg border border-white/15 px-3 py-2 text-xs text-white/70 hover:text-white">
        <Plus className="h-3.5 w-3.5" /> Agregar
      </button>
    </div>
  );
}

export function FieldRenderer({ field, value, onChange }) {
  switch (field.type) {
    case "textarea":
      return <textarea rows={4} value={value || ""} onChange={(e) => onChange(e.target.value)} className={`${inputCls} resize-none`} data-testid={`field-${field.key}`} />;
    case "number":
      return <input type="number" value={value ?? 0} onChange={(e) => onChange(Number(e.target.value))} className={inputCls} data-testid={`field-${field.key}`} />;
    case "boolean":
      return (
        <button type="button" onClick={() => onChange(!value)} data-testid={`field-${field.key}`} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${value ? "bg-glg-green" : "bg-white/15"}`}>
          <span className={`inline-block h-5 w-5 transform rounded-full bg-white transition-transform ${value ? "translate-x-5" : "translate-x-0.5"}`} />
        </button>
      );
    case "select":
      return (
        <select value={value || field.default || ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={`field-${field.key}`}>
          {field.options.map((o) => (
            <option key={o} value={o} className="bg-glg-surface">{o}</option>
          ))}
        </select>
      );
    case "image":
      return <ImageUpload value={value} onChange={onChange} testid={`field-${field.key}-upload`} />;
    case "imagelist":
      return <ImageListUpload value={value} onChange={onChange} />;
    case "list":
      return <ListField value={value} onChange={onChange} />;
    default:
      return <input type="text" value={value || ""} onChange={(e) => onChange(e.target.value)} className={inputCls} data-testid={`field-${field.key}`} />;
  }
}
